import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

// Code splitting: Lazy load UsersPage to reduce initial bundle size
const UsersPage = lazy(() => import('@/pages/admin/UsersPage'));

/**
 * Admin users list route - /admin/users
 * Shows paginated list of all users with search/filter capabilities
 */
export const adminUsersRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'users',
  component: UsersPage,
});

// Backward compatibility
export const Route = adminUsersRoute;
